"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateReservationRequestToJSON = exports.UpdateReservationRequestFromJSONTyped = exports.UpdateReservationRequestFromJSON = exports.instanceOfUpdateReservationRequest = void 0;
/**
 * Check if a given object implements the UpdateReservationRequest interface.
 */
function instanceOfUpdateReservationRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "version" in value;
    isInstance = isInstance && "startDate" in value;
    isInstance = isInstance && "endDate" in value;
    isInstance = isInstance && "country" in value;
    return isInstance;
}
exports.instanceOfUpdateReservationRequest = instanceOfUpdateReservationRequest;
function UpdateReservationRequestFromJSON(json) {
    return UpdateReservationRequestFromJSONTyped(json, false);
}
exports.UpdateReservationRequestFromJSON = UpdateReservationRequestFromJSON;
function UpdateReservationRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'version': json['version'],
        'startDate': (new Date(json['start_date'])),
        'endDate': (new Date(json['end_date'])),
        'country': json['country'],
    };
}
exports.UpdateReservationRequestFromJSONTyped = UpdateReservationRequestFromJSONTyped;
function UpdateReservationRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'version': value.version,
        'start_date': (value.startDate.toISOString()),
        'end_date': (value.endDate.toISOString()),
        'country': value.country,
    };
}
exports.UpdateReservationRequestToJSON = UpdateReservationRequestToJSON;
